import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useEloScore = (userId: string | undefined) => {
  const [eloScore, setEloScore] = useState<number | null>(null);
  const [previousElo, setPreviousElo] = useState<number | null>(null);

  useEffect(() => {
    if (!userId) return;

    const fetchInitialElo = async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('elo_rating')
        .eq('id', userId)
        .maybeSingle();

      if (error) {
        console.error('Error fetching ELO score:', error);
        return;
      }

      if (data) {
        console.log('Initial ELO fetch:', data.elo_rating);
        setEloScore(data.elo_rating);
        setPreviousElo(data.elo_rating);
      } else {
        console.log('No profile found for ELO score');
        setEloScore(null);
        setPreviousElo(null);
      }
    };

    fetchInitialElo();

    const channel = supabase
      .channel(`profile-elo-${userId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${userId}`,
        },
        (payload: any) => {
          console.log('Profile ELO update received:', payload);
          if (payload.new?.elo_rating !== undefined) {
            setPreviousElo(eloScore);
            setEloScore(payload.new.elo_rating);
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);

  return { eloScore, previousElo };
};